// Brands Icons
import {
    faFacebookSquare,
    faTwitterSquare,
    faInstagram,
    faLinkedin,
    faCcVisa,
} from '@fortawesome/free-brands-svg-icons';

// General Icons
// Font Awesome Free Version can be only from "solid-svg-icons"
import {
    faArrowCircleRight,
    faArrowRight,
    faArrowUp,
    faBars,
    faCar,
    faCaretRight,
    faCheckCircle,
    faChevronDown,
    faCreditCard,
    faEdit,
    faEye,
    faFileContract,
    faHandHoldingUsd,
    faImages,
    faMinus,
    faPlus,
    faQuestion,
    faSearch,
    faSignal,
    faSpinner,
    faTrashAlt,
    faUser,
    faUserFriends,
    faUserGraduate,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';

export const addIcons = [
    faArrowCircleRight,
    faArrowRight,
    faArrowUp,
    faBars,
    faCar,
    faCaretRight,
    faCcVisa,
    faCheckCircle,
    faChevronDown,
    faCreditCard,
    faEdit,
    faEye,
    faFacebookSquare,
    faFileContract,
    faHandHoldingUsd,
    faImages,
    faInstagram,
    faLinkedin,
    faMinus,
    faPlus,
    faQuestion,
    faSearch,
    faSignal,
    faSpinner,
    faTrashAlt,
    faTwitterSquare,
    faUser,
    faUserFriends,
    faUserGraduate,
    faUsers,
];
